module.exports = __webpack_public_path__ + "static/back-40084dd1ebc283ca250c7032852affb1.png";